import type {
  ConversationModel,
  CodableConversation,
} from '@src/service/model/conversation'
import { isUnreadConversation } from '@src/service/model/conversation'

import Repository from './base'

export class ConversationRepository extends Repository<ConversationModel> {
  async find(params: {
    phoneNumberId?: string
    directNumberId?: string
    phoneNumber?: string
  }) {
    const filter = (c: CodableConversation): boolean => {
      return (
        !c.isNew &&
        !c.deletedAt &&
        (!params.phoneNumber || c.phoneNumber === params.phoneNumber) &&
        (!params.directNumberId || params.directNumberId === c.directNumberId) &&
        (!params.phoneNumberId || params.phoneNumberId === c.phoneNumberId)
      )
    }
    const query = params.phoneNumber
      ? this.table.where('phoneNumber').equals(params.phoneNumber)
      : params.phoneNumberId
      ? this.table.where('phoneNumberId').equals(params.phoneNumberId)
      : params.directNumberId
      ? this.table.where('directNumberId').equals(params.directNumberId)
      : null

    if (!query) {
      return []
    }

    const result = await query.filter(filter).reverse().sortBy('lastActivityAt')

    return result.slice(0, 500)
  }

  async unread() {
    const objs = await this.table.where('unreadCount').above(0).toArray()
    return objs.reduce((final, conv) => {
      if (!isUnreadConversation(conv)) {
        return final
      }

      const phoneNumberId = conv.phoneNumberId

      if (!phoneNumberId) {
        return final
      }

      if (!final.has(phoneNumberId)) {
        final.set(phoneNumberId, new Set())
      }

      final.get(phoneNumberId)?.add(conv.id)

      return final
    }, new Map<string, Set<string>>())
  }
}
